import { clsx } from "clsx";
import FullBleedSetup from "./FullBleedSetup";
import styles from "./FixedHeaderScroller.module.css";

/**
 * Implementation for the fixed header + scrolling content pattern. Accounts for extra top and bottom
 * space necessary to avoid iPhone notch and status bar
 */
type FixedHeaderScrollerProps = {
  // Background classes are supplied by the caller (typically a variant
  // class from `ToolkitAppScroller` or a static class from `ToolkitMenu`).
  // Keeps the per-activity color logic out of this primitive.
  headerClassName?: string;
  contentClassName?: string;
  header: React.ReactNode;
  children: React.ReactNode;
};

export default function FixedHeaderScroller({
  headerClassName,
  contentClassName,
  header,
  children,
}: FixedHeaderScrollerProps) {
  return (
    <FullBleedSetup>
      <div className={styles.outer}>
        <div className={clsx(styles.header, headerClassName)}>{header}</div>
        {/*
         * `tabIndex={0}` makes the scrollable content region focusable so
         * keyboard users can scroll with arrow keys — satisfies axe's
         * `scrollable-region-focusable` rule and WCAG SC 2.1.1.
         */}
        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- scroll containers are interactive (kbd-operable) per WCAG SC 2.1.1; no semantic role applies */}
        <div className={clsx(styles.content, contentClassName)} tabIndex={0}>
          {children}
        </div>
      </div>
    </FullBleedSetup>
  );
}
